export class Qde {
  salutation: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string;
  pan: string;
  mothersName: string;
  nationality: string;
  resiAddressLine1: string;
  resiAddressLine2: string;
  resiAddressLine3: string;
  resiPinCode: string;
  resiCity: string;
  mobileNumber: string;
  personalEmailId: string;
  occupationType: string;
  companyName: string;
  designation: string;
  netIncome: string;
  offPinCode: string;
  officeState: string;
  eStatement: string;
  resiStdCode: string;
  sbiCardRelNumber: string;
  housingLoan: string;
  carLoan: string;
  savingsAccount: string;
  userId: string;
  channelCode: string;
  promoCode: string;
  cardType: string;
  cardCategory: string;
  sourceCode: string;
  promoGroup: string;
  geMid1: string;
  geMid2: string;
  deviceId: string;
  deviceType: string;
  sourceId: string;
  executionId: string;
  resiPhone: string;
  alternateCardNo: string;
  natureOfCompany: string;
  desigNotInList: string;
  spareNumberField: string;
  spareDateField: string;
  offCity: string;
  offStdCode: string;
  seCode: string;
  leadSeqId: any;
  cardReferralCode:any;
  leadorig: any;
}

export class friendsList {
  name: any;
  emailId: any;
  mobileNumber: any;
}

export class referralList{
  applicationNumber : any;
  firstName: any;
  lastName: any;
  referrerEmailId:any;
  referrerMobileNumber:any;
  referrals: any=[];
  source:string;
}
